export default class {
	constructor() {
		this.wrapper = '.js-story-wrapper';
		this.item = '.js-story-item';
		this.trigger = '.js-story-trigger';
		this.img = '.js-story-img';

		this.init();
	}
	init() {
		const windowWidth = window.innerWidth;
		const items = document.querySelectorAll(this.item);
		const trigger = document.querySelectorAll(this.trigger);
		const imgs = document.querySelectorAll(this.img);
		if (items) {
			window.addEventListener('resize', () => {
				setTimeout(() => {
					story();
				}, 1000);
			});
		}
		window.addEventListener('load', () => {
			story();
		})
		//アニメーション切り替え
		function story() {
			if (windowWidth <= 1008) {
				smallAnm();
			} else {
				largeAnm();
			}
		}
		//toggle
		function smallAnm() {
			trigger.forEach((element,index) => {
				element.addEventListener('click', () => {
					if (items[index].classList.contains('is-active')) {
						items[index].classList.remove('is-active');
					} else {
						items[index].classList.add('is-active');
					}
				})
			});
		}
		//hover
		function largeAnm() {
			items.forEach((element, index) => {
				element.addEventListener('mouseover', () => {
					for (let i = 0; i < items.length; i++) {
						items[i].classList.remove('is-active');
						imgs[i].classList.remove('is-active');
					}
					element.classList.add('is-active');
					imgs[index].classList.add('is-active');
				})
			});
		}
	}
}